module.exports = __webpack_public_path__ + "img/062.d8766ec4.png";